/** The language in use, from the server once signed in: the person's own, else the company's, else the browser's */
import { authApi } from '../lib/api'
import { browserLanguage, isLang, useLanguage } from './index'

export async function loadLanguage(): Promise<void> {
  try {
    const { ownLanguage, companyLanguage } = (await authApi.language()).data.data as { ownLanguage: string | null; companyLanguage: string | null }
    // the browser's from here, not the server's fallback: the dashboard sends the language it shows
    // as Accept-Language, which would keep the last company's in Platform administration
    const pick = [ownLanguage, companyLanguage].find(isLang)
    useLanguage.getState().setLang(pick ?? browserLanguage())
  } catch { /* the language stays as it is; the next sign-in or switch loads it again */ }
}

/** Signed out: the browser's language again */
export const resetLanguage = () => useLanguage.getState().setLang(browserLanguage())
